export const NUVEM_PAGO_PROVIDER_NAME = 'Nuvem Pago';
export const PAGO_NUBE_PROVIDER_NAME = 'Pago Nube';
